<template>
  <div class="footer">
    <div class="head_text fx ">
        <div class="ht_left fx f_j_sb wow animate__zoomIn">
            <div class="" v-for="item in head_list">
                <div class="ht_title color5 fs_0092 pb01">{{item.title}}</div>
                <div class="fx fx_flow_j color8 ">
                    <div class="pb_003 cursor fs_007" v-for="item1 in item.list">{{ item1 }}</div>
                </div>
            </div>
            <div class="shuxian"></div>
        </div>
        <div class="ht_right color8 wow animate__zoomIn">
            <img src="@/assets/computer/shouye/ewm.png" class="pb01" style="width: 0.4rem;height:0.4rem;">
            <div class="fs_007 pb_003">联系电话：0791-83800662</div>
            <div class="fs_007 pb_003">地址：南昌市红谷滩新区九龙湖新城VR产业基地1号楼10楼</div>
            <div class="fs_007 pb_003">网址：www.c-hone.com</div>
            <div class="fs_007">邮箱：tuyucong@163.com</div>
        </div>
    </div>
    <div class="bottom_text fs_0092"> 南昌世弘泛亚科技股份有限公司  备案号：00000000号 Copyright 2024版权所有</div>
  </div>
</template>

<script setup>
 import { useRouter } from 'vue-router'
 import {ref, nextTick, onMounted, reactive,defineProps } from "vue";
 const router = useRouter()

onMounted(() => {

});
const head_list=ref([
    {
        title:'关于我们',
        list:['公司介绍','文化理念','核心优势','发展历程','公司荣誉',]
    },{
        title:'主营事业',
        list:['数字多媒体+智慧展厅事业部','信息化技术软件开发事业部',]
    },{
        title:'案例分析',
        list:['数智慧展览展示','软件开发',]
    },{
        title:'新闻资讯',
        list:['公司新闻','行业动态',]
    },{
        title:'联系我们',
        list:['联系方式',]
    },
 ])
</script>

<style scoped>

.footer{
    width: 100%;
}
    /* 底部导航 */
    .head_text{
        width: 70%;
        padding: 0.3rem 15%;
        background-color: #333333;
    }
    .shuxian{
        border-left: 1px dashed #4e4e4e;
        padding: 0 0.2rem;
    }
    .ht_left{
        width: 70%;
    }
    .ht_right{
        width: 30%;
    }
    .bottom_text{
        width: 100%;
        padding: 0.1rem 0;
        text-align: center;
        background: red;
        color: #fff;
    }

</style>
